var exports = {
  "Sr": "Pagination.module__paginationBar___S1kwVW",
  "_s": "Pagination.module__paginationWrapper___S1kwVW",
  "gc": "Pagination.module__pageButton___S1kwVW",
  "Ks": "Pagination.module__pageButtonActive___S1kwVW",
  "oq": "Pagination.module__ellipsisButton___S1kwVW",
  "kh": "Pagination.module__pageInputForm___S1kwVW",
  "aW": "Pagination.module__pageInputLabel___S1kwVW",
  "AU": "Pagination.module__pageInput___S1kwVW",
  "Mp": "Pagination.module__focusRingCircular___S1kwVW",
};

module.exports = exports;
